




















































































import { DictionaryWordTranslation } from '@oare/types';
import { defineComponent, PropType, ref, computed } from '@vue/composition-api';
import sl from '@/serviceLocator';
import _ from 'lodash';

export interface DeletedTranslation {
  index: number;
  translation: DictionaryWordTranslation;
}

export default defineComponent({
  props: {
    wordUuid: {
      type: String,
      required: true,
    },
    translations: {
      type: Array as PropType<DictionaryWordTranslation[]>,
      required: true,
    },
    fieldType: {
      type: String,
      required: true,
    },
  },
  setup(props, { emit }) {
    const localTranslations = ref(_.cloneDeep(props.translations));

    const actions = sl.get('globalActions');
    const server = sl.get('serverProxy');
    const store = sl.get('store');

    const isEditing = ref(false);
    const isLoading = ref(false);

    const deletedTranslation = ref<DeletedTranslation | null>(null);

    const closeEditor = () => emit('close-editor');

    const saveEdits = async () => {
      if (localTranslations.value.some(({ val }) => val.trim() === '')) {
        actions.showErrorSnackbar(
          'One or more translations are blank. Either provide a translation or remove the blank fields.'
        );
        return;
      }

      try {
        isLoading.value = true;
        await server.editTranslations(props.wordUuid, {
          translations: localTranslations.value,
          fieldType: props.fieldType,
        });
        actions.showSnackbar('Successfully updated translations');
        emit('update:translations', localTranslations.value);
        emit('close-editor');
      } catch (err) {
        actions.showErrorSnackbar(
          'Failed to update translations',
          err as Error
        );
      } finally {
        isLoading.value = false;
      }
    };

    const moveTranslation = (oldIndex: number, newIndex: number) => {
      const updatedTranslations: DictionaryWordTranslation[] = [
        ...localTranslations.value,
      ];

      const temp = updatedTranslations[oldIndex];
      updatedTranslations[oldIndex] = updatedTranslations[newIndex];
      updatedTranslations[newIndex] = temp;

      localTranslations.value = updatedTranslations;
    };

    const addTranslation = () => {
      const updatedTranslations: DictionaryWordTranslation[] = [
        ...localTranslations.value,
        {
          uuid: '',
          val: '',
        },
      ];
      localTranslations.value = updatedTranslations;
    };

    const removeTranslation = (index: number) => {
      deletedTranslation.value = {
        index,
        translation: localTranslations.value[index],
      };

      localTranslations.value = [
        ...localTranslations.value.slice(0, index),
        ...localTranslations.value.slice(index + 1),
      ];

      actions.showSnackbar('Translation deleted', {
        actionText: 'Undo',
        onAction: () => {
          if (deletedTranslation.value) {
            const { index, translation } = deletedTranslation.value;
            localTranslations.value = [
              ...localTranslations.value.slice(0, index),
              translation,
              ...localTranslations.value.slice(index),
            ];
          }
        },
      });
    };

    const canUpdateTranslations = computed(() =>
      store.hasPermission('UPDATE_TRANSLATION')
    );

    return {
      moveTranslation,
      addTranslation,
      removeTranslation,
      localTranslations,
      isEditing,
      closeEditor,
      saveEdits,
      isLoading,
      canUpdateTranslations,
    };
  },
});
